import papa, { ParseResult } from 'papaparse'
import { StoredAirdropItem, StoredAirdropList } from '../state/airdrop/types'

export function parseEditorList(editorData: string, callback: (results: ParseResult<any>) => void) {
  papa.parse(editorData, {
    newline: '\n',
    skipEmptyLines: true,
    complete: callback,
    delimitersToGuess: ['=', ';', ':', ',', '|'],
  })
}

export function parseToTokenAirdropList(editorData: string) {
  const data: StoredAirdropList = []

  const parseCallback = (results: ParseResult<any>) => {
    results.data.forEach(([addr, amount, floatPart]) => {
      const _amount = floatPart ? amount + '.' + floatPart : amount

      const newElem: StoredAirdropItem = {
        addr,
        amount: _amount?.trim(),
      }

      data.push(newElem)
    })
  }

  parseEditorList(editorData, parseCallback)

  return data
}
